import { useContext } from 'react';
import { Auth0Context } from '@auth0/auth0-react';

/**
 * Custom hook that provides authentication utilities.
 * Falls back to basic auth if Auth0 is not configured.
 * 
 * Note: This hook should only be used inside Auth0Provider if Auth0 is configured.
 * If Auth0 is not configured, it returns fallback values.
 */
export const useAuth = () => {
  const auth0 = useContext(Auth0Context);

  // Check if Auth0 is configured via environment variables
  const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
  const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
  const isAuth0Configured = auth0Domain && auth0Domain.trim() && auth0ClientId && auth0ClientId.trim();
  
  // Only use Auth0 values when Auth0 is configured for this build.
  // Using context directly avoids calling hooks conditionally or inside try/catch.
  if (isAuth0Configured) {
    if (auth0) {
      return {
        isAuthenticated: auth0.isAuthenticated,
        isLoading: auth0.isLoading,
        user: auth0.user,
        loginWithRedirect: auth0.loginWithRedirect,
        logout: auth0.logout,
        getAccessTokenSilently: auth0.getAccessTokenSilently,
        getUser: auth0.getUser,
        hasAuth0: true
      };
    }

    return {
      isAuthenticated: false,
      isLoading: false,
      user: null,
      loginWithRedirect: null,
      logout: null,
      getAccessTokenSilently: null,
      getUser: null,
      hasAuth0: true
    };
  }
  
  // Fallback (Auth0 not configured)
  return {
    isAuthenticated: false,
    isLoading: false,
    user: null,
    loginWithRedirect: null,
    logout: null,
    getAccessTokenSilently: null,
    getUser: null,
    hasAuth0: false
  };
};

